import React from "react";
const CustomLabelComponent = ({
  showCustomLabel,
  setShowCustomLabel,
  customLabel,
  setIsExpanded,
  isExpanded,
}) => {
  return (
    <div class="bg-[#2A3967] rounded-md bg-opacity-20 text-white p-[12px] absolute mr-14 ml-4 z-10 top-[60px] min-w-[280px] max-w-[280px] ">
      <div className="flex flex-row justify-between">
        <div className="flex gap-x-2">
          <img
            src={require("../assets/images/info-circle.svg")}
            className="w-4 h-4"
          />
          <span className="text-[#2A3967] text-[10px] font-bold">
            Information
          </span>
        </div>
        <span
          className="text-[#2A3967] text-[10px] font-medium underline"
          onClick={() => setShowCustomLabel(!showCustomLabel)}
        >
          {showCustomLabel ? "Hide" : "Unhide"}
        </span>
      </div>
      {showCustomLabel && (
        <div className="overflow-auto h-auto max-h-[50px]">
          <p className="text-[#2A3967] text-[10px] font-medium">
            {customLabel.length <= 90 ? (
              customLabel
            ) : !isExpanded ? (
              <p>
                {customLabel.substring(0, 90)}
                <span
                  className="font-bold underline"
                  onClick={() => setIsExpanded(true)}
                >
                  {"\u00A0\u00A0Read More"}
                </span>
              </p>
            ) : customLabel.length >= 90 ? (
              <p>
                {customLabel}
                <span
                  className="font-bold underline"
                  onClick={() => setIsExpanded(false)}
                >
                  {"\u00A0\u00A0Read Less"}
                </span>
              </p>
            ) : (
              customLabel
            )}
          </p>
        </div>
      )}
    </div>
  );
};

export default CustomLabelComponent;
